import * as THREE from 'three';
import { IVideoTextureEngine } from './IVideoTextureEngine';

export class NativeVideoTextureEngine implements IVideoTextureEngine {
  public texture: THREE.Texture;
  private video: HTMLVideoElement;

  constructor(video: HTMLVideoElement) {
    this.video = video;
    
    // Standard high-performance VideoTexture
    // Three.js handles the update automatically in its render loop
    this.texture = new THREE.VideoTexture(this.video);
    this.texture.colorSpace = THREE.SRGBColorSpace;
    this.texture.minFilter = THREE.LinearFilter;
    this.texture.magFilter = THREE.LinearFilter;
  }

  start(): void {
    // Native VideoTexture manages itself mostly.
    // We can ensure the video is playing or ready here if needed,
    // but typically Three.js waits for HAVE_ENOUGH_DATA internally.
    console.log('[NativeVideoTextureEngine] Started');
  }

  update(): void {
    // No-op: THREE.VideoTexture auto-updates
  }

  destroy(): void {
    this.texture.dispose();
  }
}
